import { Layout, Section } from 'layout';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import CrmDedDetailsEnhancedListScreen from './screens/crm-ded-details-enhanced-list-screen';
import CrmDedDetailsListScreen from './screens/crm-ded-details-list-screen';

const CrmDedDetailsPage = () => {
  const match = useRouteMatch();

  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />
          <Route path={`${match.url}/list`} component={CrmDedDetailsListScreen} />
          <Route path={`${match.url}/enhanced`} component={CrmDedDetailsEnhancedListScreen} />
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default CrmDedDetailsPage;
